import React, { useEffect } from 'react';
import { Input, Typography } from 'antd';
import { CreateAssetBlock } from '../../../components';
import { Asset, AssetType } from '../../../graphql/API';
import { getDailyExerciseSummary } from '../../../utils/staticValuesUtils/dailyExerciseStaticValue';

const { Text } = Typography;

export interface DailyExerciseMetadataFormProps {
  testName: string;
  onTestNameChange: (name: string) => void;
  testDescription: string;
  onTestDescriptionChange: (description: string) => void;
  testSummary: string;
  onTestSummaryChange: (summary: string) => void;
  testAsset: Asset | undefined;
  onTestAssetChange: (asset: Asset) => void;
  thumbnail?: string;
  media?: Array<{ type: string; url: string }>;
  questionCount?: number;
}

/**
 * Form component for test-level metadata
 */
export const DailyExerciseMetadataForm: React.FC<DailyExerciseMetadataFormProps> = ({
  testName,
  onTestNameChange,
  testDescription,
  onTestDescriptionChange,
  testSummary,
  onTestSummaryChange,
  testAsset,
  onTestAssetChange,
  thumbnail,
  media,
  questionCount = 1,
}) => {

  // Recompute summary when assetType OR questionCount changes
  useEffect(() => {
    if (!testAsset) return;

    const assetType =
      testAsset.type === AssetType.PHOTO
        ? 'PHOTO'
        : testAsset.type === AssetType.VIDEO
        ? 'VIDEO'
        : '';

    const summary = getDailyExerciseSummary(assetType, questionCount);
    onTestSummaryChange(summary);
  }, [testAsset, questionCount]);

  return (
    <div style={{ marginBottom: '30px' }}>
      {/* Test Name */}
      <div style={{ marginTop: '20px', marginBottom: '20px' }}>
        <Text>Test name</Text>
        <Input
          value={testName}
          onChange={(e) => onTestNameChange(e.target.value)}
          placeholder="Test name"
        />
      </div>

      {/* Test Description */}
      <div style={{ marginTop: '20px', marginBottom: '20px' }}>
        <Text>Test description</Text>
        <Input
          value={testDescription}
          onChange={(e) => onTestDescriptionChange(e.target.value)}
          placeholder="Test description"
        />
      </div>

      {/* Test Summary (auto-generated) */}
      <div style={{ marginTop: '20px', marginBottom: '20px' }}>
        <Text>Test summary</Text>
        <Input value={testSummary} disabled />
      </div>

      {/* Test Asset */}
      <CreateAssetBlock
        asset={testAsset}
        defaultAssetType={testAsset?.type ?? AssetType.VIDEO}
        onChange={(selectedAsset) => onTestAssetChange(selectedAsset)}
      />

      {thumbnail && (
        <div style={{ marginTop: '20px', padding: '10px', border: '1px solid #d9d9d9', backgroundColor: '#f5f5f5' }}>
          <Text strong>Thumbnail:</Text>
          <br />
          <Text type="secondary" style={{ fontSize: '12px', wordBreak: 'break-all', marginTop: '5px' }}>
            {thumbnail}
          </Text>
        </div>
      )}

      {media && media.length > 0 && (
        <div style={{ marginTop: '20px', padding: '10px', border: '1px solid #d9d9d9', backgroundColor: '#f5f5f5' }}>
          <Text strong>Daily Exercise Media:</Text>
          {media.map((mediaItem: any, index: number) => (
            <div key={index} style={{ marginTop: '10px' }}>
              <Text>Media {index + 1} - Type: {mediaItem.type}</Text>
              <br />
              <Text type="secondary" style={{ fontSize: '12px', wordBreak: 'break-all' }}>
                {mediaItem.url}
              </Text>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
